var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAdvisorV4Search = function SvgIconAdvisorV4Search(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 11 7.74 7.74M1 4.912a3.913 3.913 0 1 0 7.826 0 3.913 3.913 0 0 0-7.826 0Z",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-no-fill": "true"
  })));
};
export { SvgIconAdvisorV4Search as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTIgMTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aAogICAgICAgIGQ9Ik0xMSAxMUw3LjczOTEzIDcuNzM5MTNNMSA0LjkxMzA0QzEgNy4wNzQxNiAyLjc1MTkzIDguODI2MDkgNC45MTMwNCA4LjgyNjA5QzcuMDc0MTYgOC44MjYwOSA4LjgyNjA5IDcuMDc0MTYgOC44MjYwOSA0LjkxMzA0QzguODI2MDkgMi43NTE5MyA3LjA3NDE2IDEgNC45MTMwNCAxQzIuNzUxOTMgMSAxIDIuNzUxOTMgMSA0LjkxMzA0WiIKICAgICAgICBzdHJva2U9IiMwMDAiCiAgICAgICAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogICAgICAgIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgICAgICAgZGF0YS1uby1maWxsPSJ0cnVlIgogICAgLz4KPC9zdmc+Cg==";